import { Button, Dropdown } from "antd"
import { MenuOutlined } from '@ant-design/icons';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getAuth, signOut } from "firebase/auth";
import Logo from "./Logo";

const MainMenu = ({ btnType, useLogoIcon, logoSize }) => {
  const history = useHistory();
  const idToken = localStorage.getItem("accessToken")

  const handleSignOut = () => {
    const auth = getAuth();
    signOut(auth).then(() => {
      localStorage.clear();
      history.push("/signin")
    })
  }
  
  const menuItems = [
    {
      label: 'Projects',
      key: 'projects',
      path: '/user/projects',
      show: !!idToken
    },
    {
      label: 'Account',
      key: 'account',
      path: '/user/account',
      show: !!idToken
    },
    // {
    //   label: 'Pricing',
    //   key: 'pricing',
    //   path: '/pricing',
    //   show: true
    // },
    {
      label: 'Support',
      key: 'support',
      path: '/support',
      show: true
    },
    {
      label: 'Login',
      key: 'signin',
      path: '/signin',
      show: !idToken
    },
    {
      label: 'Sign out',
      key: 'signout',
      show: !!idToken
    }
  ]

  return (
    <Dropdown
      menu={{
        items: menuItems.filter((item) => item.show)
          .map((item) => ({
            ...item,
            label: (
              <div style={{ width: 100, textAlign: 'center', fontFamily: 'Outfit' }}>
                {item.label}
              </div>
            ),
            onClick: () => {
              if (item.path) {
                history.push(item.path);
              } else if (item.mailto) {
                window.location.href = item.mailto;
              } else if (item.key === 'signout') {
                handleSignOut()
              } else if (item.url) {
                window.open(item.url, '_blank');
              }
            }
          }))
      }}
    >
      <Button style={{ color: 'black', padding: 0, height: useLogoIcon ? 27 : undefined, width: useLogoIcon ? 25 : undefined }} type={btnType || 'link'} >
        {
          useLogoIcon ?
          (
            <Logo color="#DB3F1D" width={23} height={23} />
          )
          : <MenuOutlined />
        }
      </Button>
    </Dropdown>
  )
}

export default MainMenu